import React, { useState } from 'react'
import './dropdown.css'
import { Select } from 'antd';
import { BlueArrowDown, DoubbleBlueArrowDown } from '../../../../assets/RpmAssets/SvgIcons';
const { Option } = Select;



function Dropdown({width,data, placeholder, isV2, value, onChange, options}) {

    let [dummy,setDummy]=useState(value)

    function handleChange(value) {
        console.log(`selected ${value}`);
    }
    console.log("value",value)
        

    return (
        <Select 
        onChange={onChange?(value)=>{onChange({...options, value})}:(e)=>{setDummy(e)}} 
        placeholder={placeholder}
         suffixIcon={isV2?<DoubbleBlueArrowDown/>:<BlueArrowDown/>}
         getPopupContainer={trigger => trigger.parentNode}
          value={value?value:undefined}
           className='c-dropdown'
            style={{ width: width?width:230 }}
            >
           {
               data ?

               data.map((element,key)=>{
                   return(

                    <Option key={key} value={element}>{element}</Option>
                       
                   )
               })

                :
                <Option value="jack">Jack</Option>
                
           }
        </Select>
    )
}

export default Dropdown
